// client/src/pages/clientPortal/PortalChangePasswordPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useClientPortalApiClient } from '../../hooks/useClientPortalApiClient';

const PortalChangePasswordPage = () => {
    const apiClient = useClientPortalApiClient();
    const navigate = useNavigate();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (newPassword !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }
        setIsSubmitting(true);
        try {
            const res = await apiClient.post('/api/client-portal/change-password', { new_password: newPassword });
            // A password change signs out every other session; this one continues on a fresh token.
            if (res && res.token) localStorage.setItem('clientPortalToken', res.token);
            navigate('/client-portal/dashboard');
        } catch (err) {
            setError(err.message || 'Failed to change password.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white p-8 rounded-lg shadow">
                <h1 className="text-2xl font-bold text-slate-800 mb-2 text-center">Set a New Password</h1>
                <p className="text-slate-500 text-sm mb-6 text-center">For your security, please choose a new password before continuing.</p>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <input
                        type="password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        placeholder="New password (min 8 characters)"
                        required
                        minLength={8}
                        className="w-full p-3 border rounded-md"
                    />
                    <input
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="Confirm new password"
                        required
                        className="w-full p-3 border rounded-md"
                    />
                    {error && <p className="text-red-500 text-sm">{error}</p>}
                    <button type="submit" disabled={isSubmitting} className="w-full px-4 py-3 text-white bg-slate-800 rounded-md hover:bg-slate-900 disabled:bg-indigo-400">
                        {isSubmitting ? 'Saving...' : 'Save Password'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default PortalChangePasswordPage;
